/*=========================================================================================
  File Name: moduleTodoListMutations.js
  Description: Todo List Module Mutations
==========================================================================================*/
import * as _ from "lodash";
export default {
	// API
	SET_TODO_LIST(state, todoList) {
		state.todoList = todoList;
	},
	SET_TODO_LIST_CHILD(state, todoList) {
		state.todoListChild = todoList;
	},

	SET_TOTAL_TODO_LIST(state, totalTodoList) {
		state.totalTodoList = totalTodoList;
	},

	SET_EMPLOYEES(state, employees) {
		state.employees = employees;
	},

	SET_DEVICES(state, devices) {
		state.devices = devices;
	},

	UPDATE_TODO_ITEM(state, todoItem) {
		const todoItemIndex = state.todoList.findIndex(t => t.id === todoItem.id);
		if (todoItemIndex !== -1) {
			Object.assign(state.todoList[todoItemIndex], todoItem);
		} else {
			const todoItemIndex = state.todoListChild.findIndex(t => t.id === todoItem.id);
			if (todoItemIndex !== -1) {
				Object.assign(state.todoListChild[todoItemIndex], todoItem);
			}
		}
	},

	UPDATE_TODO_ITEM_COMMENT(state, payload) {
		const todoItemIndex = state.todoList.findIndex(t => t.id === payload.todoItemId);
		if (todoItemIndex !== -1) {
			Object.assign(state.todoList[todoItemIndex], {
				comments: {
					...state.todoList[todoItemIndex].comments,
					data: [payload.newComment, ...state.todoList[todoItemIndex].comments.data]
				}
			});
		}
	},

	REMOVE_TODO_ITEM(state, payload) {
		state.todoList = _.remove(state.todoList, function(todo) {
			return todo.id !== payload.id;
		});
		state.todoListChild = _.remove(state.todoListChild, function(todo) {
			return todo.id !== payload.id;
		});
	},

	SUBMIT_REPORT_FORM_TODO_ITEM(state, payload) {
		const todoItemIndex = state.todoList.findIndex(t => t.id === payload.todoItemId);
		if (todoItemIndex !== -1) {
			const todoItemReportFormIndex = (state.todoList[todoItemIndex].forms || []).findIndex(t => t.id === payload.data.id);
			if (todoItemReportFormIndex !== -1) {
				Object.assign(state.todoList[todoItemIndex], {
					forms: state.todoList[todoItemIndex].forms.map((form, index) => {
						if (todoItemReportFormIndex === index) {
							return {
								...payload.data
							};
						}
						return form;
					})
				});
			}
		} else {
			const todoItemIndex = state.todoListChild.findIndex(t => t.id === payload.todoItemId);
			if (todoItemIndex !== -1) {
				const todoItemReportFormIndex = (state.todoListChild[todoItemIndex].forms || []).findIndex(t => t.id === payload.data.id);
				if (todoItemReportFormIndex !== -1) {
					Object.assign(state.todoListChild[todoItemIndex], {
						forms: state.todoListChild[todoItemIndex].forms.map((form, index) => {
							if (todoItemReportFormIndex === index) {
								return {
									...payload.data
								};
							}
							return form;
						})
					});
				}
			}
		}
	},

	UPDATE_TODO_MARKED_COLOR(state, payload) {
		const index = state.todoList.findIndex(t => t.id == payload.id);
		if (index !== -1) {
			Object.assign(state.todoList[index], {
				...state.todoList[index],
				user_option: {
					color: payload.color
				}
			});
		} else {
			const todoItemIndex = state.todoListChild.findIndex(t => t.id === payload.todoItemId);
			if (todoItemIndex !== -1) {
				Object.assign(state.todoListChild[index], {
					...state.todoListChild[index],
					user_option: {
						color: payload.color
					}
				});
			}
		}
	},
	UPDATE_TODO_LIST(state, newTodolist) {
		newTodolist.map(newItem => {
			const idx = _.findIndex(state.todoList, { id: newItem.id });
			if (idx !== -1) {
				state.todoList[idx] = Object.assign(state.todoList[idx], newItem);
			} else {
				state.todoList.push(newItem);
			}
		});
	},
	UPDATE_TODO_LIST_CHILD(state, todoListChild) {
		todoListChild.map(newItem => {
			const idx = _.findIndex(state.todoListChild, { id: newItem.id });
			if (idx !== -1) {
				state.todoListChild[idx] = Object.assign(state.todoListChild[idx], newItem);
			} else {
				state.todoListChild.push(newItem);
			}
		});
	},
	REMOVE_OLD_TODO_LIST(state, oldTodolist) {
		oldTodolist.map(newItem => {
			const idx = _.findIndex(state.todoListChild, { id: newItem.id });
			if (idx !== -1) {
				state.todoListChild.splice(idx, 1);
			}
		});
	},
	UPDATE_TODOLIST_COUNT(state, todolist_count) {
		state.todolistCount = todolist_count;
	},
	ADD_TODO_LIST(state, todoItem) {
		state.todoList = [todoItem, ...state.todoList];
	}
};
